module.exports = __webpack_public_path__ + "img/微风.65489d3a.png";